module.exports = __webpack_public_path__ + "static/media/Story-Cover.6464e4fd.jpg";